module.exports = "label {\n  overflow-x: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.panel-heading {\n  background-color: lightgray; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/vild/vild.component.scss
// module id = ./src/app/shared/vild/vild.component.scss
// module chunks = main